import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  ComponentMapAddRequest,
  ComponentMapDeleteResponse,
  ComponentMapEntry,
  ComponentMapListResponse,
} from "@oracus/shared/api/component-map";

import { apiClient } from "./client.ts";

const componentMapKey = (repoId: string) =>
  ["repos", repoId, "component-map"] as const;

export function useComponentMap(repoId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: componentMapKey(repoId ?? "none"),
    queryFn: () =>
      apiClient.get(
        `/api/repos/${repoId}/component-map`,
        ComponentMapListResponse,
      ),
    enabled: enabled && repoId !== null,
  });
}

export function useAddComponentMapEntry(repoId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ComponentMapAddRequest) =>
      apiClient.post(
        `/api/repos/${repoId}/component-map`,
        body,
        ComponentMapEntry,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: componentMapKey(repoId) });
    },
  });
}

export function useDeleteComponentMapEntry(repoId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entryId: string) =>
      apiClient.delete(
        `/api/repos/${repoId}/component-map/${entryId}`,
        ComponentMapDeleteResponse,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: componentMapKey(repoId) });
    },
  });
}
